<template>
  <div>
    <v-card
      class="py-3 pl-0 pb-0"
      outlined
      min-height="367px"
      :disabled="!grupoAtivo"
    >
      <v-row no-gutters>
        <v-col cols="2" class="pl-3">
          <v-icon>mdi-account</v-icon>
        </v-col>
        <v-col cols="8" align-self="end">
          <p class="pl-3 mb-0 titulos">Membros</p>
        </v-col>
        <v-col cols="2" class="text-end">
          <c-duvidas
            class="pr-3"
            titulo="Membros"
            texto="Lista de membros que pertencem ao grupo selecionado."
          ></c-duvidas>
        </v-col>
      </v-row>
      <v-card-text @scroll="carregarUsuarios()" class="lista-de-usuarios tamanho-maximo py-0 px-0" v-if="listaUsuariosGrupos.status">
        <v-list dense rounded disabled>
          <v-list-item-group v-model="usuariosSelecionados">
            <v-list-item
              color="purple ml-0"
              v-for="(item, index) in listaUsuarios"
              :key="index"
              @input="enviarUsuariosSelecionados()"
            >
              <v-list-item-avatar class="pl-0 mr-1 mb-0 mt-0">
                <v-icon class="violet white--text icon-usuario">mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="pl-0">
                <v-list-item-title v-text="item" class="listas"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-card-text style="height: 320px" v-else>
        <v-row class="fill-height" align="center" justify="center" no-gutters>
          <v-col cols="12" align-self="center" class="text-center" style="top: -50px !important">
            <span class="listas">{{ this.listaUsuariosGrupos.mensagem }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <div class="tamanho-do-icone">
        <v-progress-linear
          indeterminate
          color="primary"
          class="tamanho-total-do-icone"
          v-if="barraDeProgresso"
        ></v-progress-linear>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Duvidas from "../Duvidas";
import { receber } from "../../../mixins/RequisicaoMixin";
import { headersPadrao } from "../../../mixins/HeadersMixin";

export default {
  data() {
    return {
      quantidade: 3,
      formarUrl: "",
      limite: 0,
      clienteId: JSON.parse(localStorage.getItem("usuarioLogado")).cliente,
      usuariosSelecionados: [],
      usuariosCarregados: false,
      final: false,
    };
  },
  computed: {
    ...mapState([
      "listaUsuariosGrupos",
      "todosUsuarios",
      "listaUsuarios",
      "barraDeProgresso",
      "paginacaoDeUsuarios",
    ]),
  },
  created() {
    this.fecharListaDeUsuarios({
      status: false,
      mensagem: "Não existe usuários neste grupo",
    });
  },
  methods: {
    ...mapActions([
      "listaUsuariosDoGrupoNoComponente",
      "fecharListaDeUsuarios",
      "atualizarTodosUsuariosDoGrupo",
      "ativarBarraDeProgresso",
      "paginarUsuarios",
      "carregouUsuarios"
    ]),

    async carregarUsuarios() {
      const tamanhoDoElemento = parseInt(
        document.querySelector(".lista-de-usuarios").scrollTop +
          document.querySelector(".lista-de-usuarios").offsetHeight
      );
      const finalDoScroll = document.querySelector(".lista-de-usuarios").scrollHeight;
      if (tamanhoDoElemento >= finalDoScroll) {
        this.buscarUsuarios();
      }
    },
    async buscarUsuarios() {
      const grupoId = this.paginacaoDeUsuarios.grupoId;
      const tokenPaginacao = this.paginacaoDeUsuarios.tokenPaginacao;
      const formarUrl = `/api/v1/multisign/busca?tipo=&cliente=${this.clienteId}&grupo=${grupoId}&organizacao=&quantidade=9&pagina=${tokenPaginacao}`;
      if (this.listaUsuarios.length > 0) {
        if (tokenPaginacao !== null) {
          this.chamadaBuscarUsuarios(formarUrl, grupoId);
          return [];
        }
      }
    },
    async chamadaBuscarUsuarios(urlUsuarios, grupoId) {
      this.ativarBarraDeProgresso(true);
      this.carregouUsuarios(false);
      if (this.limite == 0) {
        this.limite += 1;
        await receber(urlUsuarios, headersPadrao())
          .then((resposta) => {
            this.desabilitar = false;
            this.verificarPaginacao(resposta, grupoId);
          })
          .catch((error) => console.error(error))
          .finally(() => {
            this.carregouUsuarios(true);
            this.ativarBarraDeProgresso(false);
          })
      }
      return [];
    },
    verificarPaginacao(usuarios, grupoId) {
      if (this.paginacaoDeUsuarios.tokenPaginacao !== null) {
        const listaDeUsuarios = this.addUsuariosEmLista(usuarios.lista);
        this.listaUsuariosDoGrupoNoComponente(listaDeUsuarios);
        this.limite -= 1;
        this.paginarUsuarios({
          grupoId: grupoId,
          tokenPaginacao: usuarios.tokenPaginacao,
        });
        return usuarios;
      }
      this.paginarUsuarios({
        grupoId: grupoId,
        tokenPaginacao: null,
      });
      return [];
    },
    addUsuariosEmLista(usuariosGrupo) {
      const listaUsuarios = [];
      usuariosGrupo.map((usuario) => {
        listaUsuarios.push(usuario.email);
      });
      return listaUsuarios;
    },
  },
  components: {
    "c-duvidas": Duvidas,
  },
  props: {
    grupoAtivo: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="css" scoped>
.icon-usuario {
  width: 30px !important;
  height: 30px !important;
}
.v-list-item {
  padding-left: 0px !important;
}

.tamanho-maximo {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
}
.tamanho-do-icone {
  height: 5px;
  width: 100%;
}
.tamanho-total-do-icone {
  width: 100%;
  bottom: -4px;
  position: relative;
}
</style>